(function () {
  const INTERVAL_MS = 5000;
  const CHECK_INTERVAL = 300; 

  let insertedPositions = {};

  function initSlider(slider) {
    if (!slider || slider.__reviewSliderInit) return;
    
    const track = slider.querySelector('[data-review-track]');
    const slides = slider.querySelectorAll('[data-review-slide]');
    
    if (!track || slides.length <= 1) return;

    slider.__reviewSliderInit = true;
    
    let currentIndex = 0;
    let startX = 0;
    let currentX = 0;
    let dragOffset = 0;
    let isDragging = false;
    const SWIPE_THRESHOLD = 50;

    function getSlideWidth() {
      return slider.offsetWidth;
    }

    function updateSlideWidths() {
      const width = getSlideWidth();
      slides.forEach(slide => {
        slide.style.width = width + 'px';
      });
    }

    updateSlideWidths();

    function goToSlide(index, animate = true) {
      currentIndex = Math.max(0, Math.min(index, slides.length - 1));
      const offset = -currentIndex * getSlideWidth();
      
      if (animate) {
        track.classList.remove('is-dragging');
      } else {
        track.classList.add('is-dragging');
      }
      
      track.style.transform = `translateX(${offset}px)`;
    }

    function next() {
      goToSlide((currentIndex + 1) % slides.length);
    }

    function prev() {
      goToSlide((currentIndex - 1 + slides.length) % slides.length);
    }

    function handleDragStart(clientX) {
      startX = clientX;
      currentX = clientX;
      isDragging = true;
      dragOffset = -currentIndex * getSlideWidth();
      track.classList.add('is-dragging');
      clearInterval(timer);
      timer = null;
    }

    function handleDragMove(clientX) {
      if (!isDragging) return;
      currentX = clientX;
      const diff = currentX - startX;
      track.style.transform = `translateX(${dragOffset + diff}px)`;
    }

    function handleDragEnd() {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
      
      const diff = currentX - startX;
      
      if (Math.abs(diff) > SWIPE_THRESHOLD) {
        if (diff < 0) {
          next();
        } else {
          prev();
        }
      } else {
        goToSlide(currentIndex);
      }
      
      startX = 0;
      currentX = 0;
      if (!timer) timer = setInterval(next, INTERVAL_MS);
    }

    track.addEventListener('touchstart', (e) => {
      handleDragStart(e.touches[0].clientX);
    }, { passive: true });

    track.addEventListener('touchmove', (e) => {
      handleDragMove(e.touches[0].clientX);
    }, { passive: true });

    track.addEventListener('touchend', handleDragEnd);
    track.addEventListener('touchcancel', handleDragEnd);

    track.addEventListener('mousedown', (e) => {
      handleDragStart(e.clientX);
      e.preventDefault();
    });

    track.addEventListener('mousemove', (e) => {
      handleDragMove(e.clientX);
    });

    track.addEventListener('mouseup', handleDragEnd);
    
    track.addEventListener('mouseleave', () => {
      if (isDragging) {
        handleDragEnd();
      }
    });

    slider.addEventListener('mouseenter', () => {
      if (!isDragging) {
        clearInterval(timer);
        timer = null;
      }
    });

    slider.addEventListener('mouseleave', () => {
      if (!isDragging && !timer) {
        timer = setInterval(next, INTERVAL_MS);
      }
    });

    let timer = setInterval(next, INTERVAL_MS);

    window.addEventListener('resize', () => {
      updateSlideWidths();
      goToSlide(currentIndex, false);
    });
  }

  function findGrid() {
    return document.getElementById('gf-products') 
      || document.getElementById('main-collection-product-grid')
      || document.querySelector('ul.product-grid')
      || document.querySelector('.product-grid');
  }

  function isTileInGridAtPosition(position) {
    const grid = findGrid();
    if (!grid) return false;
    return !!grid.querySelector(`.collection-review-tile[data-review-inserted="true"][data-position="${position}"]`);
  }

  function insertReviewTileFromSource(source) {
    const position = parseInt(source.dataset.insertPosition, 10) || 3;
    
    if (isTileInGridAtPosition(position)) return true;

    const grid = findGrid();
    if (!grid) return false;

    const gridItems = grid.querySelectorAll(':scope > li.grid__item:not(.collection-review-tile)');
    if (gridItems.length < position - 1) return false;

    const reviewTile = source.querySelector('.collection-review-tile');
    if (!reviewTile) return false;

    const clone = reviewTile.cloneNode(true);
    clone.setAttribute('data-review-inserted', 'true');
    clone.setAttribute('data-position', position);
    clone.style.cssText = 'display: block !important; visibility: visible !important; opacity: 1 !important; position: relative !important; z-index: 1 !important; min-height: 300px !important;';

    const allItems = grid.querySelectorAll(':scope > li.grid__item');
    let productCount = 0;
    let insertBeforeElement = null;
    
    for (let i = 0; i < allItems.length; i++) {
      const item = allItems[i];
      if (!item.classList.contains('collection-review-tile')) {
        productCount++;
        if (productCount === position) {
          insertBeforeElement = item;
          break;
        }
      }
    }
    
    if (insertBeforeElement) {
      grid.insertBefore(clone, insertBeforeElement);
    } else {
      grid.appendChild(clone);
    }

    const slider = clone.querySelector('[data-review-slider]');
    if (slider) initSlider(slider);

    insertedPositions[position] = true;
    return true;
  }

  function insertAllReviewTiles() {
    const sources = document.querySelectorAll('.collection-review-source');
    if (sources.length === 0) return false;
    
    // Sort sources by position (lower positions first)
    const sortedSources = Array.from(sources).sort((a, b) => {
      const posA = parseInt(a.dataset.insertPosition, 10) || 3;
      const posB = parseInt(b.dataset.insertPosition, 10) || 3;
      return posA - posB;
    });
    
    let anyInserted = false;
    sortedSources.forEach(source => {
      if (insertReviewTileFromSource(source)) {
        anyInserted = true;
      }
    });
    
    return anyInserted;
  }

  function allTilesInserted() {
    const sources = document.querySelectorAll('.collection-review-source');
    if (sources.length === 0) return true;
    
    for (const source of sources) {
      const position = parseInt(source.dataset.insertPosition, 10) || 3;
      if (!isTileInGridAtPosition(position)) {
        return false;
      }
    }
    return true;
  }

  const observer = new MutationObserver((mutations) => {
    if (allTilesInserted()) return;
    
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        
        if (node.classList?.contains('grid__item') || 
            node.id === 'gf-products' || 
            node.querySelector?.('.grid__item')) {
          insertAllReviewTiles();
          return;
        }
      }
    }
  });

  function startPersistentChecker() {
    setInterval(() => {
      const sources = document.querySelectorAll('.collection-review-source');
      if (sources.length === 0) return;
      
      if (!allTilesInserted()) {
        insertAllReviewTiles();
      }
    }, CHECK_INTERVAL);
  }

  function init() {
    observer.observe(document.body, { childList: true, subtree: true });
    insertAllReviewTiles();
    startPersistentChecker();
    
    ['globo:filter:complete', 'gf:rendered', 'gf:updated'].forEach(eventName => {
      document.addEventListener(eventName, () => {
        insertedPositions = {};
        setTimeout(insertAllReviewTiles, 50);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(insertAllReviewTiles, 300);
})();
